const createRangeParam = array => {
  return array.map(x => { return { start: x.start, end: x.end }})
}

// Apiへ送る用のパラメータを作成
const createApiConditionParam = (state, getters) => {
  // 共通部分をまずは作成
  const params = {
    publisherId: state.selectedTextbook,
    gradeId: state.selectedGrade,
    conversions: state.checkedArr.eiwa.map(v => v-1),
    speechPartIds: state.checkedArr.hinshi,
    options: state.checkedArr.target.map(v => v-1),
    wordCountAttributes: getters.sendWordCountAttributes,
    order: state.selectedQuestionSortType,
  }

  // あとは条件によって変わる部分を調整していく

  // 応用問題か
  if (getters.isCategoryAdvanced) {
    Object.assign(params, { inflectionalFormIds: state.checkedArr.katsuyo })
    Object.assign(params, { sentences: state.checkedArr.reibun.map(v => v-1) })
  }

  // ページ指定か
  if (getters.selectedRangeTypeIsPage) {
    Object.assign(params, { pageRanges: createRangeParam(getters.wasInputTangoRangePages) })
  }

  // 単元指定か
  if (getters.selectedRangeTypeIsUnit) {
    Object.assign(params, { unitIds: getters.selectedUnits.map(unit => unit.value) })
  }
  return params
}


// パラメータのバリデーション mode = searchWord or createPrint
// searchWord  = 語数検索時
// createPrint = プリント作成時
const validate = (state, getters, mode) => {
  try {
    if(!state.selectedTextbook)           throw '準拠を選択してください'
    if(!state.selectedGrade)              throw '学年を選択してください'
    if(!state.selectedCategory)           throw '問題種別を選択してください'

    // 見出し単語の場合
    if(getters.isCategoryMidashi) {
      if (state.checkedArr.eiwa.length === 0) throw '英/和を選択してください'
    }

    //応用の場合
    if(getters.isCategoryAdvanced) {
      if(state.checkedArr.reibun.length===0 && state.checkedArr.katsuyo.length===0) throw '例文問題・活用問題のいずれかを選択してください'
      // 例文が選択されていて、和英未選択か
      if (state.checkedArr.reibun.length !== 0 && state.checkedArr.eiwa.length === 0) throw '英/和を選択してください'
    }

    if(!state.selectedQuestionRangeType)    throw '範囲種別を選択してください'

    if(getters.selectedRangeTypeIsPage) {
      // 開始と終了入力されている蘭
      if(getters.wasInputTangoRangePages.length === 0) throw 'ページ範囲を入力してください'
      if(getters.wasInputTangoRangePages.filter(page => page.start > page.end).length >= 1) throw 'ページ範囲の開始ページは終了ページより小さい値を入力してください'
    }

    if(getters.selectedRangeTypeIsUnit) {
      if(getters.selectedUnits.length === 0) throw '単元を選択してください'
    }

    // 語数検索時はここまで
    if (mode === 'searchWord') return { status: 'success', message: '' }

    const nonErrorQuestionAreas = Object.entries(state.questionNumAreas)
      .some(([, attribute]) => attribute.displayFlg && attribute.value <= 0)

    if(nonErrorQuestionAreas) throw '設問数を設定してください'

    const totalCount = Object.entries(state.questionNumAreas)
      .filter(([, attribute]) => attribute.displayFlg)
      .reduce((sum, [, attribute]) => sum + attribute.value, 0)

    if(totalCount < 10) throw '最低設問数10問に満たないためテストを作成できません'

    if(totalCount > 200) throw '設問数はトータル200問以内になるように入力してください'

    if(!state.selectedQuestionSortType) throw 'ソート順を選択してください'

    if(!state.printTitle) throw 'プリント名を入力しください'

    if(state.printTitle.length > 20) throw 'プリント名は20文字以内で入力してください'

  } catch (e) {
    return { status: 'error', message: e }
  }
  return { status: 'success', message: '' }
}

export default {
  createApiConditionParam: createApiConditionParam,
  validate: validate
}
